/**
 * Phase 7 Slice 7A — the ONE cross-field rule of the Approval Request Type form,
 * mirrored from the server so the UI never offers a combination the API refuses.
 *
 * D-128 Q-6 (design §O, invariant 14): a request kind with `requiresQuotation =
 * true` MUST have `requiresCommercialReview = true`. The server enforces it twice
 * (DTO cross-field validator + service guard on the effective state) and remains
 * authoritative; this helper only decides what the form may submit and what it
 * tells the user. It introduces no routing and reads nothing else.
 */
export const QUOTATION_REQUIRES_COMMERCIAL_REVIEW_MESSAGE =
  'A request kind that requires a quotation must also require Commercial review.';

/** Returns the validation message for an invalid combination, or null when valid. */
export function quotationInvariantError(
  requiresQuotation: boolean,
  requiresCommercialReview: boolean,
): string | null {
  return requiresQuotation && !requiresCommercialReview
    ? QUOTATION_REQUIRES_COMMERCIAL_REVIEW_MESSAGE
    : null;
}
